export const builderViews = Object.freeze({
  CURRENT_BATTLECARD: 'current',
  MANAGE_ALL: 'manage'
});
